export const typesPokemon = [
    {
        type: "Normal"
    },
    {
        type: "Water"
    },
    {
        type: "Poinson"
    },
    {
        type: "Psychic"
    },
    {
        type: "Bug"
    },
    {
        type: "Dark"
    },
    {
        type: "Fire"
    },
    {
        type: "Flying"
    },
    {
        type: "Eletric"
    },
    {
        type: "Rock"
    },
    {
        type: "Dragon"
    },
    {
        type: "Steel"
    },
    {
        type: "Fighting"
    },
    {
        type: "Grass"
    },
    {
        type: "Ground"
    },
    {
        type: "Ice"
    },
    {
        type: "Ghost"
    },
    {
        type: "Fairy"
    },
]